import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

/**
 * Componente para lidar com rotas de uploads
 * Este componente não renderiza nada visualmente, mas impede que o React Router
 * redirecione URLs de uploads para o dashboard
 */
const UploadsHandler: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  
  useEffect(() => {
    // Extrair o caminho real do arquivo a partir da URL
    const filePath = location.pathname;
    
    // Verificar se é uma URL de upload válida
    if (filePath.startsWith('/uploads/')) {
      console.log('Acessando arquivo de upload:', filePath);
      
      // Verificar se já estamos sendo redirecionados (para evitar loop)
      const redirectParam = new URLSearchParams(location.search).get('direct');
      if (redirectParam === 'true') {
        console.log('Já estamos sendo redirecionados, não fazer nada para evitar loop');
        return;
      }
      
      // Em vez de redirecionar diretamente para a URL da imagem,
      // vamos redirecionar para o componente ImageViewer
      navigate(`/view-image?path=${encodeURIComponent(filePath)}`);
      
      // Isso evita o loop de redirecionamento, pois o ImageViewer
      // vai exibir a imagem em vez de redirecionar novamente
    }
  }, [location, navigate]);

  // Este componente não renderiza nada visualmente
  return null;
};

export default UploadsHandler;
